require('../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/navbar_top.template.htm');
require('dhtmlxMessage');
var i18n = require('l10n');

var TheView = GenericView.extend({
    el: $("#header"),
    tagName: 'header',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	userData: null,
	orgData: null,
	numberPrivilegeLevel: null,
	pageHeader: "",
	langs: {},
	initialize: function (options) {
	    this.langs = {
            "el": "gr",
            "en": "gb"
        };

		this.userData = options.data;
		this.orgData = options.org;
		this.pageHeader = options.pageHeader;
		this.numberPrivilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel)
        this.render();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		var organizationName = "";
		if(this.orgData)
		{
			organizationName = " - "+this.orgData.name;
		}

		this.$el.html(this.template(
		{
			username: this.userData.userName,
			role: this.getRolePrompt(this.userData.privilegeLevel),
			privilegeLevel: this.numberPrivilegeLevel,
			venueId: this.userData.venueId,
			organizationName: organizationName,
			pageHeader: (!this.pageHeader ? "" : i18n.t("pageHeader."+ this.pageHeader)),
			lang: this.getLangCode(i18n.lng())
		}));

		this.$('#language-selector li a').each(function(a) {
            self.$(this).click(function(evt) {
                var lang = self.$(this).data("lang");
                i18n.setLng(lang);
                evt.preventDefault(); //stop page from reloading
                location.reload();
            })
        });
	},
	events:{
	"click #logout" : "logout",
	"click #test" : "test"
	},
    getLangCode: function(lng) {
        //return appropriate language code, for the `flag-icon` library
        return this.langs[lng];
    },
	logout: function(){
		var self = this;
		if( $.ajaxq.isRunning("DefaultQueue"))
			$.ajaxq.abort("DefaultQueue");
		$.ajaxDefaultQ({
			url: '/rest/api/logout',
			type: 'POST',
		}).done(function(response, status, xhr){
			window.open('./','_self');
		})
		.fail(function(response) {

		});
	},
	getRolePrompt: function(privilegeLevel)
	{
		var prompt = i18n.t("user.you_are") + " ";
		if(privilegeLevel == "SupervisingAdmin") {
			return prompt+i18n.t("user.supervising");
		}
		else if(privilegeLevel == "OrganizationAdmin") {
			return prompt+i18n.t("user.organization_admin");
		}
		else if(privilegeLevel == "VenueAdmin") {
			return prompt+i18n.t("user.venue_admin");
		}
		else if(privilegeLevel == "VenueAgent") {
			return prompt+i18n.t("user.venue_agent");
		}

		return prompt+" a God"
	},
	test: function(){
		var self = this;

		$.ajaxDefaultQ({
			url: '/rest/main/test',
			type: 'GET',
		}).done(function(response, status, xhr){
			//console.info("test done");
		})
		.fail(function(response) {
			//console.info("test fail");
		});
	}

});


module.exports= TheView;